import { useState } from "react";
import { Pencil, History } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { hasRight } from "@/components/crm/crmShared";
import DossierNumber from "@/components/common/DossierNumber";
import RenumberDialog from "./RenumberDialog";

const MONO = { fontFamily: "'JetBrains Mono', Consolas, monospace" };

/** iter452 pt 3.1 — numéro de dossier cliquable (droit « Modifier le numéro d'un document ») → fenêtre « Modifier le n° du dossier ».
 *  Sans le droit : affichage simple (DossierNumber), non cliquable. */
export default function RenumberButton({ kind, docId, numero, onChanged, history = [], legacy, size = 13, color = "#FCD34D", testId }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [hover, setHover] = useState(false);
  const tid = testId || `renumber-${kind}-${docId}`;
  if (!hasRight(user, "crm.edit_doc_number")) return <DossierNumber numero={numero} history={history} legacy={legacy} color={color} size={size} testid={tid} />;
  return (
    <>
      <button type="button" title="Modifier le n° du dossier" onClick={(e) => { e.stopPropagation(); setOpen(true); }} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)} className="inline-flex items-center tabular-nums"
        style={{ ...MONO, gap: 5, fontSize: size, fontWeight: 700, color, padding: "2px 8px", borderRadius: 7, border: `1px ${hover ? "solid #E8B52E" : "dashed #5C4813"}`, background: hover ? "#2A2210" : "transparent", lineHeight: 1.3, transition: "border-color .12s, background-color .12s" }} data-testid={tid} data-numero={numero}>
        {numero || "—"}{(history?.length > 0 || legacy) && <History size={11} style={{ color: "#8b8b93" }} />}{hover && <Pencil size={13} color="#E8B52E" />}
      </button>
      {open && <RenumberDialog open kind={kind} docId={docId} onClose={() => setOpen(false)} onChanged={onChanged} />}
    </>
  );
}
